import React from 'react';
import PropTypes from 'prop-types';
import DateRange from '../DateRange/DateRange';
import css from './styles.less';
import classnames from 'classnames';

class CalendarPart extends React.Component {

    render() {
        const {
            checkinAvailability,
            checkoutAvailability,
            availabilityLoading,
            openDirection,
            lang,
            titles,
            notValid,
            direction,
            checkinDate,
            checkoutDate,
            openAllDates,
            focusedInput,
            displayDateFormat,
            onChangeCheckinDate,
            onChangeCheckoutDate,
            onNextMonthClick,
            onPrevMonthClick,
            onFocusChange,
            offlineAvailability,
            isWindowMobileView,
            initialCalendarDate
        } = this.props;

        return (
            <div className={classnames(css.calendar, "sbox-row")}>
                <div className={classnames(css.dateInput, "sbox-col-xs-12", "sbox-col-md-12")}>
                    <DateRange
                        offlineAvailability={offlineAvailability}
                        openDirection={openDirection}
                        checkoutAvailability={checkoutAvailability}
                        checkinAvailability={checkinAvailability}
                        availabilityLoading={availabilityLoading}
                        lang={lang}
                        titles={titles}
                        notValid={notValid}
                        direction={direction}
                        checkinDate={checkinDate}
                        checkoutDate={checkoutDate}
                        focusedInput={focusedInput}
                        displayDateFormat={displayDateFormat}
                        onChangeCheckinDate={onChangeCheckinDate}
                        onChangeCheckoutDate={onChangeCheckoutDate}
                        onNextMonthClick={onNextMonthClick}
                        onPrevMonthClick={onPrevMonthClick}
                        onFocusChange={onFocusChange}
                        openAllDates={openAllDates}
                        isWindowMobileView={isWindowMobileView}
                        initialCalendarDate={initialCalendarDate}
                    />
                </div>
            </div>
        );
    }
};

CalendarPart.propTypes = {
    openDirection: PropTypes.string,
    isRounded: PropTypes.bool,
    direction: PropTypes.oneOf(['left', 'right']),
    checkinDate: PropTypes.any,
    checkoutDate: PropTypes.any,
    openAllDates: PropTypes.bool,
    checkinAvailability: PropTypes.object,
    checkoutAvailability: PropTypes.object,
    availabilityLoading: PropTypes.bool,
    onChangeCheckinDate: PropTypes.func,
    onChangeCheckoutDate: PropTypes.func,
    onNextMonthClick: PropTypes.func,
    onPrevMonthClick: PropTypes.func,
    onClickOpenCalendar: PropTypes.func,
    titles: PropTypes.object,
    validity: PropTypes.object,
    initialCalendarDate: PropTypes.string
};

CalendarPart.defaultProps = {
};

export default CalendarPart;



// WEBPACK FOOTER //
// ./src/components/CalendarPart/CalendarPart.js